module.exports = __webpack_public_path__ + "img/icon_bw.cbdc9106.png";